import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.isOpen ? _ctx.$emit('close') : _ctx.$emit('open'))),
      class: _normalizeClass({open:$props.isOpen})
    }, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _cache[1] || (_cache[1] = _createTextVNode("Dropdown"))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dropdown-arrow" }, [
        _createElementVNode("svg", {
          class: "icon chevron-down chevron",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            class: "path filled",
            d: "M5.41 6L10 10.58L14.59 6L16 7.41L10 13.41L4 7.41L5.41 6Z"
          })
        ])
      ], -1))
    ], 2),
    ($props.isOpen)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}